@use '@scss' as *;

@layer module {
.recurring-toggle-box {
            border-width: 1px;
            border-style: solid;
    }

.recurring-toggle-box-header {
            display: flex;
            align-items: center;
    }

.recurring-toggle-box-text {
            flex: 1;
    }

.recurring-toggle-box-fields {
            border-top-width: 1px;
            border-top-style: solid;
    }
} // layer module










@layer app {
.recurring-toggle-box {
            border-radius: $size-8;
            padding: $size-16;
            margin: $size-20 0;
    }

.recurring-toggle-box-header {
            gap: $size-12;
    }

.recurring-toggle-box-subtitle {
            margin-top: $size-2;
    }

.recurring-toggle-box-fields {
            margin-top: $size-16;
            padding-top: $size-16;
    }

.recurring-toggle-box {
            border-color: var(--border-default);
    }

.recurring-toggle-box-title {
            color: var(--text-primary);
            font-size: var(--font-size-base);
            font-weight: 600;
            line-height: $size-17;
    }

.recurring-toggle-box-subtitle {
            color: var(--text-secondary);
            font-size: var(--font-size-sm);
            line-height: $size-15;
    }

.recurring-toggle-box-fields {
            border-top-color: var(--border-default);
    }
} // layer app
